/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Restore_Undo_HintInputs */



/**
* | output |
* | --- |
* | "You can undo the restore with Ctrl+Z or Redo restore." |
*
* @param {Assistant_Restore_Undo_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_restore_undo_hint = /** @type {((inputs?: Assistant_Restore_Undo_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Restore_Undo_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous pouvez annuler la restauration avec Ctrl+Z ou rétablir la restauration.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie können die Wiederherstellung mit Strg+Z rückgängig machen oder die Wiederherstellung wiederholen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("È possibile annullare il ripristino con Ctrl+Z o Ripeti ripristino.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Восстановить можно с помощью Ctrl+Z или команды «Повторить восстановление».")
	if (locale === "es") return /** @type {LocalizedString} */ ("Puedes deshacer la restauración con Ctrl+Z o Rehacer restauración.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("您可以使用 Ctrl+Z 或“重新恢复”来撤销恢复操作。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Ctrl+Zを押すか、「復元をやり直す」を選択すると、復元を取り消すことができます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आप Ctrl+Z दबाकर रिस्टोर को अनडू कर सकते हैं या रिडू रिस्टोर का उपयोग कर सकते हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Você pode desfazer a restauração com Ctrl+Z ou Refazer restauração.")
	return /** @type {LocalizedString} */ ("You can undo the restore with Ctrl+Z or Redo restore.")
});